import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { getTokenCount, selectUserData } from '@/api/rtk/userSelectors'
import { handleLogout } from '@/features/auth/lib/authSession'
import settingIcon from '@/images/SVG/settingIcon.svg'
import { Dialog, DialogContent, DialogTrigger } from "@/shared/ui/dialog"
import AddToken from '@/features/profile/AddToken'
import { Button } from "@/shared/ui/button"
import { LogOut } from 'lucide-react'
import { FaRegCircleQuestion as HelpIcon } from "react-icons/fa6"
import { useTranslation } from 'react-i18next'
import { HELP_URL } from '@/shared/config/urls'

const DesktopActions = ({ 
  addTokenOpen, 
  setAddTokenOpen 
}) => {
  const { t } = useTranslation()
  const tokens = useSelector(getTokenCount)
  const user = useSelector(selectUserData)

  return (
    <div className='flex gap-6 items-center'>
      {(tokens || tokens === 0) && (
        <h2 className='md:flex hidden text-[16px] font-bold font-SuisseIntlLight tracking-wider min-w-max'>
          {tokens?.toLocaleString('en')} {t('tokens.title')}
        </h2>
      )}
      
      {user?.is_admin && (
        <Dialog open={addTokenOpen} onOpenChange={setAddTokenOpen}>
          <DialogTrigger asChild>
            <Button variant='outline' className='hidden md:flex text-[#09090B]'>
              {t('tokens.add')}
            </Button>
          </DialogTrigger>
          <DialogContent className="rounded-3xl">
            <AddToken setIsOpen={setAddTokenOpen} />
          </DialogContent>
        </Dialog>
      )}
      
      <a href={HELP_URL} target="_blank" rel="noopener noreferrer" className='md:flex hidden'>
        <HelpIcon size={20} className='text-[#525866] cursor-pointer' />
      </a>
      
      <Link to='/settings' className='md:flex hidden -mr-[1px] min-w-max'>
        <img src={settingIcon} alt={t('navigation.settings')} />
      </Link>
      
      <LogOut 
        onClick={handleLogout} 
        size={20} 
        className='text-[#525866] -ml-[1px] cursor-pointer hidden md:flex min-w-max' 
      />
    </div>
  )
}

export default DesktopActions
